import { default as SelectAtlaskit } from '@atlaskit/select';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { Control, Controller, useForm } from 'react-hook-form';
import { Options, SingleValue } from 'react-select';

import { customStylesSelectInput } from '@/themes/customStyle';
import { OptionSelect } from '@/types';

interface IProps {
    options: Options<OptionSelect>;
    defaultValue?: OptionSelect;
    placeholder?: string;
    label?: string;
    name?: string;
    components?: any;
    control?: Control;
    onChange?: (value: OptionSelect) => void;
}
export const Select: FC<IProps> = ({ options, placeholder, components, label, defaultValue = null, name = 'name', control, onChange }) => {
    const form = useForm();
    return (
        <Box>
            {label && (
                <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
                    {label}
                </Typography>
            )}
            <Controller
                name={name}
                defaultValue={defaultValue}
                sx={{ width: '100%' }}
                control={control ?? form.control}
                render={({ onChange: onChangeHook, value }) => (
                    <SelectAtlaskit
                        onChange={(e: any) => {
                            onChangeHook(e);
                            onChange && onChange(e);
                        }}
                        value={value}
                        components={components}
                        options={options}
                        placeholder={placeholder}
                        styles={customStylesSelectInput as any}
                    />
                )}
            />
        </Box>
    );
};
